// Lote 126 — regra pura das sugestões (sem tela), testável sem navegador.
export const semAcento = (t) => String(t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// Função pura (testável): devolve até `max` itens de `lista` que combinam com `texto`.
// Começa-com vem antes de contém; o item idêntico ao que já está digitado não é sugerido.
export function filtrarSugestoes(lista, texto, { max = 5, minimo = 2, digitos = false } = {}) {
  const bruto = String(texto || "").trim();
  if (!Array.isArray(lista) || bruto.length < minimo) return [];
  const q = digitos ? bruto.replace(/\D/g, "") : semAcento(bruto);
  if (q.length < (digitos ? 3 : minimo)) return [];
  const chave = (x) => (digitos ? String(x).replace(/\D/g, "") : semAcento(x));
  const ini = [], meio = [];
  for (const item of lista) {
    const k = chave(item);
    if (!k || k === q) continue;
    if (k.startsWith(q)) ini.push(item);
    else if (k.includes(q)) meio.push(item);
    if (ini.length >= max) break;
  }
  return [...ini, ...meio].slice(0, max);
}

